import Modal from './Modal';
import ModalBody from './body';
import ModalFooter from './footer';
export * from '@trilogy-ds/react/lib/components/modal/ModalEnum';
export { Modal, ModalBody, ModalFooter };
//# sourceMappingURL=index.js.map